function App() {
  return (
    <div className="App">
      <section className="hero is-small background">
        <div className="hero-body">
          <p className="title has-text-centered is-size-1 has-text-white">NapicuPC Numax's PC Setup</p>
        </div>
      </section>
      <div className="container">
        <section className="section">
          <div>
            <div className="container">
              <div className="content">
                <h1 className="is-size-1 title has-text-white">Můj počítač</h1>
                <p className="is-size-4 has-text-white">
                  Počítač slouží především na programování, úpravu fotek a videí, sledování videí a na
                  nenáročné hraní Minecraftu.
                </p>
              </div>
            </div>
            <section className="section">
              <div className="columns">
                <div className="column">
                  <table className="dark-table ">
                    <tbody>
                      <tr>
                        <th>Skříň</th>
                        <td>
                          <a
                              href="https://www.alza.cz/endorfy-ventum-200-solid-black-d7617311.htm"
                              target="_blank"
                              rel="noreferrer"
                          >
                            Endorfy Ventum 200 Solid Black
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>Základní deska</th>
                        <td>
                          <a
                            href="https://www.alza.cz/asus-prime-h310m-r-r2-0-d5535927.htm"
                            target="_blank"
                            rel="noreferrer"
                          >
                            ASUS PRIME H310M-R R2.0
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>CPU</th>
                        <td>
                          <a
                            href="https://www.alza.cz/intel-core-i5-9400f-d5530456.htm"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Intel Core i5-9400F
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>GPU</th>
                        <td>
                          <a
                            href="https://www.alza.cz/asus-tuf-geforce-gtx-1650-4gd6-gaming-d6315145.htm"
                            target="_blank"
                            rel="noreferrer"
                          >
                            ASUS TUF GeForce GTX 1650 4GD6
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>Zdroj</th>
                        <td>
                          <a
                            href="https://www.alza.cz/corsair-cv550-d5759762.htm"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Corsair CV550 - 550W
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>Chladič</th>
                        <td>
                          <a
                            href="https://www.alza.cz/endorfy-fera-5-d7617315.htm"
                            target="_blank"
                            rel="noreferrer"
                          >
                            SilentiumPC Fera 5
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>RAM-1</th>
                        <td>
                          <a
                            href="https://www.alza.cz/hyperx-8gb-ddr4-2400mhz-cl15-fury-black-series-d4128817.htm"
                            target="_blank"
                            rel="noreferrer"
                          >
                            HyperX 8GB DDR4 2400MHz CL15 FURY series
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>RAM-2</th>
                        <td>
                          <a
                            href="https://www.alza.cz/hyperx-8gb-ddr4-2400mhz-cl15-fury-white-series-d4827386.htm"
                            target="_blank"
                            rel="noreferrer"
                          >
                            HyperX 8GB DDR4 2400MHz CL15 Fury White Series
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>Disk1</th>
                        <td>
                          <a
                            href="https://www.alza.cz/samsung-860-evo-250gb-d5258007.htm"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Samsung 860 EVO 250GB
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>Disk2</th>
                        <td>
                          <a
                              href="https://www.alza.cz/crucial-bx500-500gb-d7356759.htm"
                              target="_blank"
                              rel="noreferrer"
                          >
                            Crucial BX500 500GB
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>Disk3</th>
                        <td>
                          <a
                            href="https://www.alza.cz/crucial-bx500-1tb-d5782027.htm"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Crucial BX500 1TB
                          </a>
                        </td>
                      </tr>
                      {/*<tr>*/}
                      {/*  <th>Ventilátory</th>*/}
                      {/*  <td>*/}
                      {/*    <a*/}
                      {/*      href="https://www.czc.cz/arctic-f9-pwm-pst-black-92mm/312721/produkt"*/}
                      {/*      target="_blank"*/}
                      {/*      rel="noreferrer"*/}
                      {/*    >*/}
                      {/*      2x Arctic F9 PWM PST Black, 92mm*/}
                      {/*    </a>*/}
                      {/*  </td>*/}
                      {/*</tr>*/}
                      <tr>
                        <th>Reproduktory</th>
                        <td>
                          <a
                            href="https://reprosoustavy-reproduktory.heureka.cz/presonus-eris-e4_5"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Presonus Eris E4.5
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>Monitor</th>
                        <td>
                          <a
                            href="https://www.alza.cz/24-samsung-s24r650-d5761114.htm"
                            target="_blank"
                            rel="noreferrer"
                          >
                            2x Samsung S24R650 - 24"
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>Držák pro monitory</th>
                        <td>
                          <a
                            href="https://www.alza.cz/alzaergo-ergoarm-d35b-d5626008.htm"
                            target="_blank"
                            rel="noreferrer"
                          >
                            AlzaErgo Arm D35B
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>Klávesnice</th>
                        <td>
                          <a
                            href="https://www.alza.cz/dark-project-kd83a-navy-blue-d12430612.htm"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Dark Project KD83A Navy Blue
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>Myš</th>
                        <td>
                          <a
                            href="https://www.alza.cz/glorious-model-o-matte-black-d5698339.htm"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Glorious Model O-
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>Stůl</th>
                        <td>
                          <a
                              href="https://www.ikea.com/cz/cs/p/bekant-ram-pro-stolni-desku-cerna-30252906/"
                              target="_blank"
                              rel="noreferrer"
                          >
                            Bekant (Deska custom)
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>Operační systém</th>
                        <td>
                          <a
                            href="https://www.czc.cz/microsoft-windows-10-pro-cz-64bit-dvd-oem/175668/produkt"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Microsoft Windows 10 Pro 64bit
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="column">
                  <img src="/setup/pc.webp" className="imgSetup" alt="Počítačová skříň" />
                </div>
              </div>
            </section>
          </div>

          <div className="mt-6">
            <div className="container">
              <div className="content">
                <h1 className="is-size-1 title has-text-white">Podrobnější vnitřek počítače</h1>
              </div>
            </div>
            <section className="section">
              <h1 className="is-size-2 title has-text-white">Intel Core i5-9400F</h1>
              <div className="columns">
                <div className="column is-size-5 has-text-white">
                  <p>
                    Jako srdcem tohoto počítače je 6 jádrový, 6 vláknový a 65W procesor, který dosahuje
                    3.98GHz na všech jader. Procesor jsem zakoupil z důvodu nedostatku výkonu Pentia G-5400 s
                    2 jádry a 4 vlákny na taktu 3.7GHz. Takže mi tento procesor zvládá vše co na svou práci a
                    zábavu potřebuji, jak programování, nenáročné hry tak i virtualizaci.
                  </p>
                </div>
                <div className="column">
                  <img src="/setup/cpu.webp" className="imgSetup" alt="Procesor Intel Core i5-9400F" />
                </div>
              </div>
            </section>
            {/*<section className="section">*/}
            {/*  <h1 className="is-size-2 title">ASUS PRIME H310M-R R2.0</h1>*/}
            {/*  <div className="columns">*/}
            {/*    <div className="column is-size-5">*/}
            {/*      <p>*/}
            {/*        Z důvodu malé počítačové skříně a nízkých financí, jsem musel šáhnout po Micro-ATX deskách*/}
            {/*        s chipsetem H310. Jelikož je má skříň malá a nemohu do ní dát více jak 1 HDD, nezajímal mě*/}
            {/*        ani počet sata konektorů. Jako základní desku jsem si tedy vybral ASUS PRIME H310M-R R2.0*/}
            {/*        která má socket 1151. <br /> Deska obsahuje 4x SATA 6Gb/s, 4x USB 3.1 Gen1, 6x USB 2.0 (2x*/}
            {/*        na zadním panelu, 4x na desce).*/}
            {/*      </p>*/}
            {/*    </div>*/}
            {/*    <div className="column">*/}
            {/*      <img src="/deska.webp" className="imgSetup" alt="Základní deska ASUS PRIME H310M-R R2.0" />*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</section>*/}
            <section className="section">
              <h1 className="is-size-2 title has-text-white">SilentiumPC Fera 5</h1>
              <div className="columns">
                <div className="column">
                  <img src="/setup/fera.webp" className="imgSetup" alt="Chladič SilentiumPC Fera 5" />
                </div>
                <div className="column is-size-5 has-text-white">
                  <p>
                    Tento 120 mm chladič byl zakoupen po pár týdnech používaní boxovaného chlazení dodávané k
                    i5-9400F. Boxované chladiče dodávané k Intel procesorům jsou hlučné a né moc výkonné,
                    musel jsem tedy koupit nový. Chladič Fera 5 se mi líbila jak vzhledově, výkonově tak i
                    cenově, takže jsem neváhal a koupil! Při testovaní v Cinebenchu jsem se dostal na
                    maximální teploty 60 °C s téměř nulovým hlukem.
                  </p>
                </div>
              </div>
            </section>

            <section className="section">
              <h1 className="is-size-2 title has-text-white">Operační paměť</h1>
              <div className="columns">
                <div className="column is-size-5 has-text-white">
                  <p>
                    Původně jsem si do sestavy pořídil pouze 1x 8GB 2400MHz operační paměť v černé barvě.
                    Postupem času mi kapacita paměti přestávala stačit, a tak jsem se rozhodl přikoupit další,
                    přičemž vzhledem k nedostupnosti černé verze jsem zvolil variantu bílou.
                  </p>
                </div>
                <div className="column">
                  <img src="/setup/ram.webp" className="imgSetup" alt="Operační paměti" />
                </div>
              </div>
            </section>

            <section className="section">
              <h1 className="is-size-2 title has-text-white">ASUS TUF GeForce GTX 1650 4GD6</h1>
              <div className="columns">
                <div className="column">
                  <img src="/setup/gpu.webp" className="imgSetup" alt="Grafická karta MSI GT 710, 1GB" />
                </div>
                <div className="column is-size-5 has-text-white">
                  <p>
                    Grafický výkon v počítači zajišťuje grafická karta GeForce GTX 1650, která mi na občasné hraní plně vyhovuje a nijak mě neomezuje
                  </p>
                </div>
              </div>
            </section>

            <section className="section">
              <h1 className="is-size-2 title has-text-white">Samsung 860 EVO 250GB</h1>
              <div className="columns">
                <div className="column is-size-5 has-text-white">
                  <p>
                    V počítači jsem měl dlouho 60GB SSD, které nebylo příliš rychlé.
                    Kvůli nízké kapacitě jsem ho vyměnil za Samsung 860 EVO 250GB, na kterém mám pouze operační systém, což mi plně vyhovuje
                  </p>
                </div>
                <div className="column">
                  <img src="/setup/ssd1.webp" className="imgSetup" alt="SSD Samsung 860 EVO 250GB" />
                </div>
              </div>
            </section>

            <section className="section">
              <h1 className="is-size-2 title has-text-white">Crucial BX500 480GB</h1>
              <div className="columns">
                <div className="column">
                  <img src="/setup/ssd2.webp" className="imgSetup" alt="SSD Samsung 860 EVO 250GB" />
                </div>
                <div className="column is-size-5 has-text-white">
                  <p>
                    V počítači se nachází SSD disk Crucial BX500, který mi slouží k ukládání
                    důležitých souborů a aplikací, k nimž potřebuji rychlý přístup.
                    Dále je v systému přítomen identický model disku, avšak s vyšší kapacitou, čímž je
                    zajištěna dostatečná rezerva pro rozšiřující se datové nároky
                  </p>
                </div>
              </div>
            </section>

            {/*<section className="section">*/}
            {/*  <h1 className="is-size-2 title has-text-white">Seagate IronWolf 1TB</h1>*/}
            {/*  <div className="columns">*/}
            {/*    <div className="column is-size-5 has-text-white">*/}
            {/*      <p>*/}
            {/*        Pro ukládání her a nedůležitých dokumentů mi dostačuje tento 1TB. Tento disk je určený primárně pro NAS*/}
            {/*        server, já ho však provozuji ve svém stolním počítači.*/}
            {/*      </p>*/}
            {/*    </div>*/}
            {/*    <div className="column">*/}
            {/*      <img src="/setup/hddns.webp" className="imgSetup" alt="HDD Samsung HD502IJ 500GB" />*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</section>*/}

            <section className="section">
              <h1 className="is-size-2 title has-text-white">Corsair CV550 - 550W</h1>
              <div className="columns">
                <div className="column">
                  <img src="/setup/zdroj.webp" className="imgSetup" alt="Zdroj Corsair CV550 - 550W" />
                </div>
                <div className="column is-size-5 has-text-white">
                  <p>
                    Tento zdroj jsem zakoupil současně s procesorem i5-9400F, a to z důvodu pochybností o
                    kvalitě předchozího zdroje, u kterého nebylo možné zjistit jeho původ.
                    Tento 550W model s certifikací 80Plus Bronze mi poskytne dostatečnou rezervu i pro případné decentní upgrady.
                  </p>
                </div>
              </div>
            </section>

            <section className="section">
              <h1 className="is-size-2 title has-text-white">Endorfy Zephyr 120mm</h1>
              <div className="columns">
                <div className="column is-size-5 has-text-white">
                  <p>
                    Počítačová sestava musí zajišťovat adekvátní průtok vzduchu.
                    V tomto systému je tedy nainstalován ventilátor Endorfy Zephyr 120mm,
                    který se efektivně podílí na odvodu tepla ze skříně.
                  </p>
                </div>
                <div className="column">
                  <img src="/setup/fan.webp" className="imgSetup" alt="Ventilátory Arctic F9 PWM PST Black, 92mm" />
                </div>
              </div>
            </section>
          </div>

          <div className="mt-6">
            <div className="container">
              <div className="content">
                <h1 className="is-size-1 title has-text-white">Další fotky počítače</h1>
              </div>
            </div>
            <div className="columns mt-5 is-desktop is-vcentered is-justify-content-space-around ">
              <img src="/setup/pc1.webp" className="imgSetupBottom" alt="Fotka počítače"/>
            </div>
            <div className="columns mt-5 is-desktop is-vcentered is-justify-content-space-around ">
              <img src="/setup/pc3.webp" className="imgSetupBottom" alt="Fotka počítače"/>
            </div>
            <div className="columns mt-5 is-desktop is-vcentered is-justify-content-space-around ">
              <img src="/setup/pc2.webp" className="imgSetupBottom" alt="Fotka počítače"/>
            </div>
            <div className="columns mt-5 is-desktop is-vcentered is-justify-content-space-around ">
              <img src="/setup2-new.webp" className="imgSetupBottom" alt="Fotka celého setupu"/>
            </div>
            <div className="columns mt-5 is-desktop is-vcentered is-justify-content-space-around ">
              <img src="/setup1-new.webp" className="imgSetupBottom" alt="Fotka celého setupu"/>
            </div>
            <div className="columns mt-5 is-desktop is-vcentered is-justify-content-space-around ">
              <img src="/setup/pc_night.webp" className="imgSetupBottom" alt="Fotka celého setupu v noci"/>
            </div>
          </div>
        </section>
      </div>

      <footer className="footer background">
        <div className="content has-text-centered has-text-white">
          <div>
            <h2 className="has-text-white">Created by Numax with ❤️ </h2>
          </div>
          <div>
            The source code is licensed
            <a href="http://opensource.org/licenses/mit-license.php"> MIT</a>
          </div>
          <div>
            <a href="https://github.com/Numax-cz/NapicuPC" target="_blank" rel="noreferrer">
              <img src="/github.png" className="gitImg mt-2" alt="Github" />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
